import { Component, EventEmitter, Output, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

import { ApiService } from "src/app/api.service";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-organization",
	templateUrl: "./manage-organization.component.html",
	styleUrls: ["./manage-organization.component.scss"],
	imports: [FormsModule, ActionButtonComponent]
})
export class ManageOrganizationComponent {
	private api = inject(ApiService);
	private activatedRoute = inject(ActivatedRoute);

	@Output()
	UpdateTree: EventEmitter<void> = new EventEmitter<void>();

	public organization: APIResults.Organization;
	public newFleetName: string;

	constructor() {
		this.activatedRoute.params.pipe(takeUntilDestroyed()).subscribe((params) => {
			this.RefreshOrganization(Number(params["orgid"]));
		});
	}

	public async RefreshOrganization(organization_id: number) {
		this.organization = undefined;
		this.organization = await this.api.GetOrganization(organization_id);
	}

	public async AddFleet() {
		if (!this.newFleetName) {
			throw new Error("Fleet name required");
		}
		await this.api.AddOrgFleet(this.organization.organization_id, this.newFleetName);
		this.UpdateTree.emit();
		this.newFleetName = undefined;
	}

}
